// Module
var code = "<template>\n\n  <header class=\"app__content__header\">\n    <div class=\"app__content__header__title\">\n      <h2><slot name=\"title\"></slot></h2>\n    </div>\n    <div class=\"app__content__header__actions button-group button-group--align-right\">\n      <slot name=\"actions\"></slot>\n    </div>\n  </header>\n\n</template>\n";
// Exports
export default code;